import { reactive } from 'vue'

export const feedback = reactive({ message: '', tone: 'info', id: 0 })
let timer
let shownAt = 0

/** 同一失败的请求层和页面反馈合并，重复操作仍可重新提示。 */
export function showFeedback(message, tone = 'info') {
  const text = String(message?.message || message || '').trim()
  if (!text) return
  const now = Date.now()
  if (feedback.message === text && now - shownAt < 800) {
    if (tone === 'error') feedback.tone = 'error'
    return
  }
  clearTimeout(timer)
  feedback.message = text
  feedback.tone = ['error', 'success', 'warning', 'info'].includes(tone) ? tone : 'info'
  feedback.id += 1
  shownAt = now
  timer = setTimeout(dismissFeedback, tone === 'error' ? 5000 : 3000)
}

export function dismissFeedback() {
  clearTimeout(timer)
  feedback.message = ''
}

/** 本地同步校验反复得到相同文案时，也能再次显示提示。 */
export function reportError(message) {
  if (message) showFeedback(message, 'error')
  return message
}
